<template>
    <select-option
        data-testid="select-all-option"
        :label="label"
        :show-checkbox="false"
        :value="state.selectAllValue"
        ref="optionRef"
    >
        <activix-checkbox
            class="mr-3"
            data-testid="select-all-checkbox"
            size="sm"
            :tristate="true"
            :model-value="checkboxValue"
            @update:model-value="onInput"
            v-if="state.multiple"
        />
        <span class="block truncate" data-testid="select-all-label" v-text="label" />
    </select-option>
</template>

<script lang="ts" setup>
    import { computed, inject, ref } from 'vue';
    import ActivixCheckbox from '@/components/activix-ui/ActivixCheckbox/ActivixCheckbox.vue';
    import SelectOption from '@/components/activix-ui/ActivixSelect/ActivixSelectOption.vue';
    import { useI18n } from '@/hooks/useI18n.ts';
    import type { SelectState } from '@/components/activix-ui/ActivixSelect/types.ts';

    const { t } = useI18n();

    const props = defineProps<{
        allSelected: boolean;
        partiallySelected: boolean;
    }>();

    const state = inject<SelectState>('state')!;

    const optionRef = ref<InstanceType<typeof SelectOption> | null>(null);

    const label = computed(() => {
        return t('clientCard.select.all');
    });

    const checkboxValue = computed(() => {
        if (props.allSelected) {
            return true;
        }

        if (props.partiallySelected) {
            return null;
        }

        return false;
    });

    const onInput = () => {
        optionRef.value?.onSelect();
    };
</script>
